import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim() || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() || '';

// Check if environment variables are placeholder values or missing
const isPlaceholderUrl = !supabaseUrl || supabaseUrl === 'your_supabase_project_url_here';
const isPlaceholderKey = !supabaseAnonKey || supabaseAnonKey === 'your_supabase_anon_key_here';

let supabase: any;

if (isPlaceholderUrl || isPlaceholderKey) {
  console.warn('⚠️ Supabase not configured yet. Please click "Connect to Supabase" to set up your database connection.');
  
  // Create a dummy client that will throw helpful errors when used
  supabase = {
    auth: {
      signUp: () => Promise.reject(new Error('Please connect to Supabase first')),
      signInWithPassword: () => Promise.reject(new Error('Please connect to Supabase first')),
      signOut: () => Promise.reject(new Error('Please connect to Supabase first')),
      getSession: () => Promise.resolve({ data: { session: null }, error: null }),
      getUser: () => Promise.resolve({ data: { user: null }, error: null }),
      refreshSession: () => Promise.resolve({ data: { session: null }, error: null }),
      onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } })
    },
    from: () => ({
      select: () => Promise.reject(new Error('Please connect to Supabase first')),
      insert: () => Promise.reject(new Error('Please connect to Supabase first')),
      update: () => Promise.reject(new Error('Please connect to Supabase first')),
      delete: () => Promise.reject(new Error('Please connect to Supabase first'))
    }),
    storage: {
      from: () => ({
        upload: () => Promise.reject(new Error('Please connect to Supabase first')),
        download: () => Promise.reject(new Error('Please connect to Supabase first')),
        remove: () => Promise.reject(new Error('Please connect to Supabase first')),
        getPublicUrl: () => ({ data: { publicUrl: '' } }),
        createSignedUrl: () => Promise.reject(new Error('Please connect to Supabase first'))
      })
    },
    rpc: () => Promise.reject(new Error('Please connect to Supabase first'))
  };
} else {
  // Validate URL format only if it's not a placeholder
  try {
    new URL(supabaseUrl);
  } catch (error) {
    console.error('Invalid VITE_SUPABASE_URL format:', supabaseUrl);
    throw new Error('VITE_SUPABASE_URL must be a valid URL (e.g., https://your-project-id.supabase.co)');
  }

  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    },
  });

  // Test connection on initialization
  supabase.from('products').select('id').limit(1)
    .then(() => {
      console.log('✅ Supabase connection established successfully');
    })
    .catch((error: any) => {
      console.error('❌ Supabase connection failed:', error);
      console.error('Please check your VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in the .env file');
      console.error('Current URL:', supabaseUrl);
      console.error('Current Key (first 20 chars):', supabaseAnonKey.substring(0, 20) + '...');
    });
}

export { supabase };